import { AnalyticsBrowser } from '@segment/analytics-next';
import { ENVIRONMENT, IS_PROD } from '../../../../constants';
import { Analytics, CreateAnalytics, Context, TrackEvent } from './segment.types';
import { isZeroSample } from './isZeroSample';

const segmentKeys = {
  production: 'g8Y7cpfGC4EhnMZjwbdsW57ZJNJ5GOr1',
  review: '8gfLc26L9pl0MAhdv1DL6YpH0SWBHHMZ',
  integration: 'dFYonYdG4ZSAjUwehl8IRfAV8Kmr9w0x',
};

const segment = IS_PROD ? AnalyticsBrowser.load({ writeKey: segmentKeys[ENVIRONMENT] }) : undefined;

const createAnalytics: CreateAnalytics = () => {
  const context: Context = {};
  const addContext: Analytics['addContext'] = (data) => {
    Object.assign(context, data);
  };

  const track: Analytics['track'] = (key, data) => {
    if (!segment || isZeroSample()) {
      // eslint-disable-next-line no-console
      console.debug(`Segment ${key}`, { ...context, ...data });
      return;
    }
    if (key === 'Page Viewed') {
      return segment.page((data as TrackEvent['Page Viewed']).name);
    }
    return segment.track(key, { ...context, ...data });
  };

  return {
    addContext,
    track,
  };
};

let analytics: Analytics | undefined = undefined;

export const getAnalytics = () => {
  return analytics ?? (analytics = createAnalytics());
};
